export const normalizeRateFilterIds = (
  selectedRateIds: string[],
  availableRateIds: string[]
) => {
  const selectedRateIdSet = new Set(selectedRateIds)
  const normalizedRateIds: string[] = []
  const normalizedRateIdSet = new Set<string>()
  availableRateIds.forEach((rateId) => {
    if (
      selectedRateIdSet.has(rateId) &&
      !normalizedRateIdSet.has(rateId)
    ) {
      normalizedRateIdSet.add(rateId)
      normalizedRateIds.push(rateId)
    }
  })
  return normalizedRateIds
}

export const haveSameRateFilterIds = (
  firstRateIds: string[],
  secondRateIds: string[]
) => {
  if (firstRateIds.length !== secondRateIds.length) return false
  const firstRateIdSet = new Set(firstRateIds)
  return secondRateIds.every((rateId) => firstRateIdSet.has(rateId))
}

export const getRateListFilter = (rateIds: string[]) =>
  rateIds.length > 0 ? rateIds : undefined
